export default __webpack_public_path__ + "static/media/bag3.ec8e8b00.jpg";